import {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {useHistory} from 'react-router-dom'
import {State} from '../../../../reducers'
import {Pagination} from '../../../../components/Pagination'
import FilterButton from '../../../../components/Tables/TableComponent/FilterButton'
import BasicCardDocumentos from '../../../MasOpciones/Components/DatosDeCierre/BasicCardDocumentos'
import ModalCargarFileClientes from './ModalCargarFileClientes'
import {postCargarClientes} from '../../../../actions/gestion-cliente/agregar-cliente/agregarClienteFile.actions'
import {GESTION_CLIENTES_TYPES} from '../../../../constants/gestionCliente.types'
import './tableDataCargadaClientes.styles.css'

const ITEMS_POR_PAGINA = 20

const TableDataCargadaClientes = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  const clientes = useSelector(
    (state: State) => state.gestionCliente.agregarCliente.clientesFileDataCargada
  )

  const [modalCargarFile, setModalCargarFile] = useState<boolean>(false)
  const [currentItems, setCurrentItems] = useState<any[]>([])
  const [sortedArray, setSortedArray] = useState<any[]>([])
  const [progress, setProgress] = useState<number>(0)

  useEffect(() => {
    setSortedArray(currentItems)
  }, [currentItems])

  useEffect(() => {
    if (!clientes?.length) {
      history.push('/gestion-clientes/agregar-cliente')
    }
  }, [clientes, history])

  useEffect(() => {
    return () => {
      dispatch({type: GESTION_CLIENTES_TYPES.AC_CLEAR_FILE_DATA})
    }
  }, [dispatch])

  const handleCargar = async () => {
    setProgress(10)
    const result = await postCargarClientes(clientes, () => {
      setProgress(100)
      setTimeout(() => {
        history.push('/gestion-clientes/agregar-cliente')
      }, 1000)
    })(dispatch)

    if (result) {
      setProgress(100)
    }
  }

  return (
    <>
      {modalCargarFile && (
        <ModalCargarFileClientes
          onAccept={() => setModalCargarFile(false)}
          onClose={() => setModalCargarFile(false)}
        />
      )}
      <div className='w-layout-layout bill-section wf-layout-layout'>
        <BasicCardDocumentos
          style={{boxShadow: 'none', padding: '0'}}
          title='Validar datos'
          size='l'
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'start',
              marginTop: '8px',
              marginBottom: '16px',
            }}
          >
            <button className='m button w-auto' onClick={() => setModalCargarFile(true)}>
              Cargar nuevo cliente
            </button>
          </div>

          {progress > 0 && progress < 100 && (
            <div style={{marginBottom: '8px'}}>Cargando clientes... {progress}%</div>
          )}

          <div className='tab-plane'>
            <div className='table-facturacion-resp'>
              <table className='table-main-responsive responsive-table-main td-left table-pointer'>
                <thead>
                  <tr>
                    <td>#</td>
                    <td>
                      Tipo Doc.{' '}
                      <FilterButton
                        keyName='tipoDocumento'
                        data={sortedArray}
                        state={setSortedArray}
                      />
                    </td>
                    <td>
                      Nº Documento{' '}
                      <FilterButton
                        keyName='numDocumento'
                        data={sortedArray}
                        state={setSortedArray}
                      />
                    </td>
                    <td>
                      Nombre{' '}
                      <FilterButton keyName='nombre' data={sortedArray} state={setSortedArray} />
                    </td>
                    <td>
                      Departamento{' '}
                      <FilterButton
                        keyName='departamento'
                        data={sortedArray}
                        state={setSortedArray}
                      />
                    </td>
                    <td>
                      Municipio{' '}
                      <FilterButton keyName='municipio' data={sortedArray} state={setSortedArray} />
                    </td>
                    <td>
                      Dirección{' '}
                      <FilterButton keyName='direccion' data={sortedArray} state={setSortedArray} />
                    </td>
                    <td>
                      Email{' '}
                      <FilterButton keyName='email' data={sortedArray} state={setSortedArray} />
                    </td>
                    <td>
                      Teléfono{' '}
                      <FilterButton keyName='telefono' data={sortedArray} state={setSortedArray} />
                    </td>
                    <td>
                      NRC <FilterButton keyName='nrc' data={sortedArray} state={setSortedArray} />
                    </td>
                    <td>
                      Correo CC{' '}
                      <FilterButton keyName='correocc' data={sortedArray} state={setSortedArray} />
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {sortedArray.map((cliente, idx) => (
                    <tr key={idx}>
                      <td data-label='#'>{idx + 1}</td>
                      <td data-label='Tipo Doc.'>{cliente.tipoDocumento}</td>
                      <td data-label='Nº Documento'>{cliente.numDocumento}</td>
                      <td data-label='Nombre'>{cliente.nombre}</td>
                      <td data-label='Departamento'>{cliente.departamento}</td>
                      <td data-label='Municipio'>{cliente.municipio}</td>
                      <td data-label='Dirección'>{cliente.direccion}</td>
                      <td data-label='Email'>{cliente.email}</td>
                      <td data-label='Teléfono'>{cliente.telefono}</td>
                      <td data-label='NRC'>{cliente.nrc}</td>
                      <td data-label='Correo CC'>{cliente.correocc}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {clientes?.length > 0 && (
                <Pagination data={clientes} items={ITEMS_POR_PAGINA} state={setCurrentItems} />
              )}
            </div>
          </div>

          {sortedArray.length > 0 && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'end',
                marginTop: '16px',
                marginBottom: '16px',
              }}
            >
              <button className='m button w-auto' onClick={handleCargar}>
                Cargar {clientes?.length} cliente{clientes?.length !== 1 ? 's' : ''}
              </button>
            </div>
          )}
        </BasicCardDocumentos>
      </div>
    </>
  )
}

export default TableDataCargadaClientes
